import { Platform, StyleSheet } from 'react-native';
import { Spacing } from '../../styles';
import { Colors } from '../../themes/colors';
import { SaveButton } from './saveButton';
import { TopBar } from './topBar';
import { TopComponentBarBaseProps } from './types';

export const TopComponentBar = (props: TopComponentBarBaseProps) => {
  const isWeb = Platform.OS === 'web';
  const left = props.left || props.backButton;
  const right =
    props.right ||
    (props.showSave ? (
      <SaveButton
        onPress={props.onRightPress!}
        disabled={props.rightPressDisabled}
        label={props.saveLabel}
        fontSize={!isWeb ? 14 : undefined}
        style={[
          styles.baseButton,
          props.rightPressDisabled
            ? styles.addButtonDisabled
            : styles.addButtonEnabled,
        ]}
      />
    ) : undefined);

  return (
    <TopBar
      style={props.style}
      left={left}
      title={props.title}
      right={right}
      additionalHeaderBlock={props.additionalHeaderBlock}
    />
  );
};

const styles = StyleSheet.create({
  baseButton: {
    width: 60,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 8,
    marginRight: Spacing.baseMargin.base,
  },
  addButtonDisabled: {
    backgroundColor: Colors.grayDivider,
  },
  addButtonEnabled: {
    backgroundColor: Colors.primary,
  },
});
